import { withTranslation } from "next-i18next";
import { useCurrentUser } from "@hooks/use-current-user";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import { useFormatDate } from "@hooks/use-format-date";
import Button from "@components/core/Button";
import ClosetItemsList from "@components/core/ClosetItemsList";
import closetStates from "@utils/constants/closetStates";
import ClosetPromoBannerContainer from "../DrawerClosetReceived/ClosetPromoBannerContainer";

function UnlockEarlyIntroduction({ goToUnlockEarlyValidationStep, t }) {
  const user = useCurrentUser();
  const nextInvoiceDate = user.next_invoice_date;
  const currentCloset = useCustomizableCloset();
  const formatDate = useFormatDate();

  const subtitle = () => {
    const nextClosetDateExplanation = t(
      "common:drawer.modal_unlock_early.introduction.subtitle.next_closet_date_explanation",
      { date: formatDate(nextInvoiceDate) },
    );

    switch (currentCloset.state) {
      case closetStates.received:
      case closetStates.postReturned:
      case closetStates.returned:
      case closetStates.lost:
        return nextClosetDateExplanation;
      case closetStates.purchased:
        return t("common:drawer.modal_unlock_early.introduction.subtitle.purchased", {
          nextClosetDateExplanation,
        });
    }
  };

  const trackingName = () => {
    switch (currentCloset.state) {
      case closetStates.received:
        return "drawerReceived_UnlockEarlyTunnel";
      case closetStates.postReturned:
        return "drawerPostReturned_UnlockEarlyTunnel";
      case closetStates.returned:
        return "drawerReturned_UnlockEarlyTunnel";
      case closetStates.lost:
        return "drawerLost_UnlockEarlyTunnel";
      case closetStates.purchased:
        return "drawerPurchased_UnlockEarlyTunnel";
      default:
        return "_UnlockEarlyTunnel";
    }
  };

  return [
    <div
      className="drawer-body"
      key="unlock-early-introduction-body"
    >
      <div className="bg-white p-3">
        <div className="px-3 d-flex flex-column justify-content-center">
          <h5 className="text-center mb-2">
            {t(`common:drawer.modal_unlock_early.introduction.title.${currentCloset.state}`)}
          </h5>

          <p className="text-center mb-0 text-gray">{subtitle()}</p>
          {currentCloset.state === closetStates.received &&
            currentCloset.mail_box_picking_date_requested_at && (
              <p className="px-2 text-gray mb-0 text-center">
                {t("common:drawer.modal_closet_received.mail_box_picking_request_done")}
              </p>
            )}
        </div>
      </div>

      <ClosetPromoBannerContainer />

      <div className="px-2 mt-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>,
    <div
      className="bg-white p-3 w-100 border-top border-light mt-2"
      key="unlock-early-introduction-footer"
    >
      <Button
        variant="primary"
        fullWidth
        onClick={goToUnlockEarlyValidationStep}
        trackingName={trackingName()}
      >
        {t("common:drawer.modal_unlock_early.introduction.unlock_early")}
      </Button>
    </div>,
  ];
}

export default withTranslation("common")(UnlockEarlyIntroduction);
